module.exports = __webpack_public_path__ + "media/media/cases/rosneft/video_preview-c20a8a8a77ebf4f7a320c8fb0d6f1f53.jpg";